import { fetchItems } from '../items';
import { ResourceType } from '../../../../../shared/types/resourceType';

/**
 * Fetch sellers with pagination.
 */
export const fetchSellers = (lastItemId) => fetchItems(ResourceType.SELLER, lastItemId);
